import { Component, Injector, OnInit } from '@angular/core';
import { AuthService } from '@auth0/auth0-angular';
import { firstValueFrom } from 'rxjs';
import { AbstractWorkspaceComponent } from '../../shared/abstract-workspace-component';
import { workspaceProviders } from '../workspace-providers';

// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection -- Outputs don't show up correctly with OnPush :(. Not sure why.
@Component({
  selector: 'h3-login-workspace',
  templateUrl: './login-workspace.component.html',
  styleUrls: [],
  providers: workspaceProviders,
  standalone: false,
})
export class LoginWorkspaceComponent
  extends AbstractWorkspaceComponent
  implements OnInit
{
  constructor(
    private authService: AuthService,
    injector: Injector,
  ) {
    super('login', injector);
  }

  override async ngOnInit() {
    await super.ngOnInit();

    const appState = await firstValueFrom(this.authService.appState$);

    this.browserControlService.navigateTo(appState.href);
  }

  protected buildWorkspaceConfig() {
    return {
      name: this.name,
      projectId: -1,
      user: this.currentUser,
    };
  }

  protected override async loadModels() {}

  protected override handleModelsLoaded() {}
}
